var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckCircleFilled = function SvgCheckCircleFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C14.0265 1.5 15.8686 1.99118 17.4242 2.87125C18.9797 3.75132 20.2487 5.02027 21.1288 6.57583C22.0088 8.13139 22.5 9.97354 22.5 12C22.5 14.0265 22.0088 15.8686 21.1288 17.4242C20.2487 18.9797 18.9797 20.2487 17.4242 21.1288C15.8686 22.0088 14.0265 22.5 12 22.5C9.97354 22.5 8.13139 22.0088 6.57583 21.1288C5.02027 20.2487 3.75132 18.9797 2.87125 17.4242C1.99118 15.8686 1.5 14.0265 1.5 12C1.5 9.97354 1.99118 8.13139 2.87125 6.57583C3.75132 5.02027 5.02027 3.75132 6.57583 2.87125C8.13139 1.99118 9.97354 1.5 12 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5379 8.33709C17.904 8.7032 17.904 9.2968 17.5379 9.66291L11.5379 15.6629C11.1718 16.029 10.5782 16.029 10.2121 15.6629L6.83709 12.2879C6.47097 11.9218 6.47097 11.3282 6.83709 10.9621C7.2032 10.596 7.7968 10.596 8.16291 10.9621L10.875 13.6742L16.2121 8.33709C16.5782 7.97097 17.1718 7.97097 17.5379 8.33709Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-circle-filled.b8cb70002dc038730400ad995f26fe29.svg";